import { defineType } from 'sanity';

export default defineType({
	name:   'navigationMenuItem',
	type:   'object',
	title:  'Navigation Menu Item',
	fields: [
		{
			name:  'title',
			type:  'localizedText',
			title: 'Menu Title',
		},
		{
			name:  'href',
			type:  'string',
			title: 'Href (URL)',
		},
		{
			name:  'children',
			title: 'Sub Menu Items',
			type:  'array',
			of:    [ { type: 'navigationMenuItem' } ],
		},
	],
	preview: {
		select: {
			title: 'title.en',
			href:  'href',
		},
		prepare({ title, href }) {
			return {
				title:    title || href || 'Untitled',
				subtitle: href,
			};
		},
	},
});